// NOTE: post.stats is currently populated only from LinkedIn. If you extend this
// to YouTube, YouTube API Services Policy III.E.4 caps retention of API-derived
// statistics at 30 days — you must add a purge/refresh job for YouTube rows and
// update store_youtube_api_length / refresh_youtube_api_rate on the Google API
// Compliance form for project 657186336300. (Audit ref: ToS Report V.1, 2026-05-19)

export function computeDashboardTotals(items = []) {
  return items.reduce(
    (acc, item) => {
      const stats = item?.post?.stats?.at(-1); // latest stats for that post
      if (!stats) return acc;

      const views = Number(stats.views) || 0;
      const likes = Number(stats.likes) || 0;
      const comments = Number(stats.comments) || 0;

      acc.views += views;
      acc.likes += likes;
      acc.comments += comments;

      if (likes > acc.mostLikesValue) {
        acc.mostLikesValue = likes;
        acc.mostLikedPost = item.post;
      }

      return acc;
    },
    {
      views: 0,
      likes: 0,
      comments: 0,
      mostLikesValue: 0,
      mostLikedPost: null,
    },
  );
}

export function toTotalStatistics(totals) {
  return {
    stats: [
      {
        likes: totals.likes,
        views: totals.views,
        comments: totals.comments,
      },
    ],
  };
}
